<template>
  <div class="invite-page">
    <div class="invite-content">

      <div class="invite-tip">向展商发送邀约后，展商同意后将安排接待人员与您进行对接</div>

      <div class="invite-title">邀约时间</div>
      <div class="invite-area">
        <div class="invite-field" @click="showPicker = true">
          <div class="field-label">{{dateValue}}</div>
          <div class="field-value"><van-icon name="arrow" /></div>
        </div>
        <div class="invite-field" @click="showTime = true">
          <div class="field-label">{{timeValue}}</div>
          <div class="field-value"><van-icon name="arrow" /></div>
        </div>
      </div>

      <div class="invite-title">邀约地点</div>
      <div class="invite-area">
        <div class="invite-field" v-for="(address, index) in addressList" :key="address.code" @click="onClick(index)">
          <div class="field-label">{{address.name}}</div>
          <div class="field-radio">
            <div class="circle" :class="{active: currentIndex === index}"></div>
          </div>
        </div>
      </div>
    </div>

    

    <div class="invite-info">
      <div class="invite-title-wrap">
        <div class="invite-title">邀约展商</div>
      </div>
      <div class="invite-actor" v-for="i in 10" :key="i">
        <div class="invite-actor-item" v-for="item in subjectList" :key="item.id">
          <template v-if="subjectType === 'VISITOR'">
            <div class="actor-logo">
              <van-image
                round
                width="42"
                height="42"
                fit="contain"
                :src="item.logoImage"
              />
            </div>
            <div class="actor-name ellipsis-1">{{item.name}}</div>
          </template>
        </div>
      </div>
    </div>

    
    <div class="invite-btn" @click="onSend">发送邀约</div>


    <van-popup v-model="showPicker" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        cancel-button-text="关闭"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
      >
        <template #title>
          <span>邀约日期</span>
        </template>
      </van-datetime-picker>
    </van-popup>

    <van-popup v-model="showTime" round position="bottom">
      <van-picker
        ref="pickerRef"
        title=""
        show-toolbar
        cancel-button-text="关闭"
        :columns="timeRange"
        @confirm="onTimeConfirm"
        @cancel="onTimeCancel"
      >
      <template #title>
        <span>邀约时间</span>
      </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
  import { mapGetters} from 'vuex'

  export default {
    data() {
      return {
        dateValue: "",
        timeValue: "09:00-12:00",
        showPicker: false,
        showTime: false,
        minDate: "",
        maxDate: "",
        currentDate: "",
        timeRange: ['09:00-12:00', '12:00-17:00'],
        addressList:[
          { name: "商贸对接区", code: 'PENDING' },
				  { name: "展台见面", code:'APPROVE' }
        ],
        currentIndex: 0,
        exhibitorId: null, // 展商id
        exhibitorInfo: {},
        subjectList: []
      }
    },
    computed: {
      ...mapGetters(['subjectType', 'exhibitionId'])
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.getUrlParams()
        this.getExhibition()
        this.getExhibitor()
      },
      getUrlParams() {
        const query = this.$route.query
        this.exhibitorId = query.id

        // this.$store.commit('changeToken', 'PBB+hfqyCn5u/Asp+KqEaql+riiDg+NdnR+4JLbLiRkNJAVfZWQRQliIW+PfhAedIR9UFAh4EYWGM7SDznjHP1VNW0ma+7iqcceRTUlyI1itzNbEwChzTTyFT1yCy60bLgonoHSrxtb11Z61F4KI/fHPY2Z8zSzUU2o916Cj9sEEqACDiAJSdezPmrHnsatyOzW/VpsctfwzSKd3usbvke39mc7TF/N39b/k+2zpqiFYCs78lWlJov0QcOXrsr8G2cqScWxNhpMg1GaE23Y3ygpe6y/6ldRuYt1TpIA709i1QNH82iw4acYSlDXjnZYDaoGmEHUhzs9t9LPhi6DSauZBtFVCNlK/kYF2MrMZnvAQ4bXUAbH99VxgGLQ7/ufI31CVnuN/Rgmii0ydRbcFRqdtnSPS0scLUtOrYSmO/TZO7GJwgNh0myWPxIs14TqQKZgVEt69OxrrkPhFVaNghD4qIrlpdFxw0iKY9JH4ergP/zi5tFYth5H1o07TKNSoqt6otjTa+PZvSsd5VfFzt0bYP50S8tYzmEid1cX2Py5FEMj+QaBEg2oWPqgP2Sr5')
        this.$store.commit('changeToken', decodeURIComponent(query.token))
        this.$store.commit('changeExhibitionId', query.exhibitionId)
        this.$store.commit('changeAppID', query.appId)
        this.$store.commit('changeSubjectType', query.subjectType)

        console.log(query)
      },
      onSend() {
        if (!this.dateValue) {
          return this.$Toast('请选择邀约日期')
        }
        if (!this.timeValue) {
          return this.$Toast('请选择邀约时间')
        }

        const appoint = {
          appointDate: this.dateValue,
					appointPlaceCode: this.addressList[this.currentIndex]["code"],
					appointPlace: this.addressList[this.currentIndex]["name"],
					appointTime: this.timeValue,
        }

        const appointments = this.subjectList.map(item => {
          if (this.subjectType === "VISITOR") {
            appoint.exhibitorId = this.exhibitorId
          } else {
            appoint.visitorId = item.operateSubjectId || item.id
          }
          return appoint
        })

        console.log(appointments)

        // this.$http.getExhibition.invite(appointments).then(res => {
        //   if (res.code === 1000) {}
        // })
      },
      getExhibition() {
        this.$http.getExhibition({ exhibitionId: this.exhibitionId }).then(res => {
          console.log(res)
          if (res.code === 1000) {
            const data = res.data
            if (data.startTime) {
              const { year, month, day } = this.getYearsMonthDays(data.startTime)
              this.minDate = new Date(year, month, day)
              this.currentDate = new Date(year, month, day)
              this.dateValue = this.$dayjs(this.currentDate).format("YYYY-MM-DD")
            }
            if (data.endTime) {
              const { year, month, day } = this.getYearsMonthDays(data.endTime)
              this.maxDate = new Date(year, month, day)
            }
          }
        })
      },
      getExhibitor() {
        const params = {
          id: this.exhibitorId
        }
        this.$http.getExhibitorDetails(params).then(res => {
          if (res.code === 1000) {
            const data = res.data
            if (!data.logoImage) {
              data.logoImage = 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/uniapp/actor.png'
            }
            this.exhibitorInfo = data
            this.subjectList = [data]
          }
        })
      },
      formatter(type, val) {
        if (type === 'year') {
          return `${val}年`;
        } else if (type === 'month') {
          return `${val}月`;
        } else if (type === "day") {
          return `${val}日`
        }
        return val
      },
      onConfirm(value) {
        this.dateValue = this.$dayjs(value).format("YYYY-MM-DD")
        this.showPicker = false
      },
      onTimeConfirm(value, index) {
        this.timeValue = value
        this.showTime = false
      },
      onCancel() {
        this.showPicker = false;
      },
      onTimeCancel() {
        this.showTime = false
      },
      getYearsMonthDays(timestamp) {
        const date = this.$dayjs(timestamp)
        return {
          year: date.year(),
          month: date.month(),
          day: date.date()
        }
      },
      onClick(index) {
        this.currentIndex = index
      }
    }
  }
</script>

<style lang="scss" scoped>
  .invite-page {
    width: 100%;
    background: #ffffff;
    min-height: 100vh;
    .invite-content {
      padding: 12px 15px 0;
      box-sizing: border-box;
      .invite-tip {
        font-weight: 400;
        font-size: 12px;
        color: #EFBB89;
        padding: 8px 12px;
        box-sizing: border-box;
        border-radius: 4px;
        background: #FDF6EB;
        margin-bottom: 12px;
      }
      .invite-area {
        padding: 4px 0 12px;
      }
      .invite-field {
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(199, 199, 199, .2);
        height: 42px;
        line-height: 42px;
        color: #969696;
        .field-label {
          flex: 1;
          font-weight: 400;
          font-size: 15px;
        }
        .field-radio {
          width: 16px;
          height: 16px;
          border: 1px solid #BFBFBF;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          .circle {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #ffffff;
            &.active {
              background: #163ccc;
            }
          }
        }
      }
    }

    .invite-title {
      font-weight: 500;
      font-size: 16px;
      color: #424242;
    }
    .invite-info {
      margin-top: 6px;
    }
    .invite-title-wrap {
      padding: 0 15px;
    }
    .invite-actor {
      padding: 12px 0;
      box-sizing: border-box;
      .invite-actor-item {
        display: flex;
        align-items: center;
        padding: 8px 15px;
        background: #FAFAFA;
        margin-bottom: 5px;
        &:last-child {
          margin-bottom: 0;
        }
        .actor-logo {
          width: 42px;
          height: 42px;
        }
        .actor-name {
          flex: 1;
          padding-left: 15px;
          font-weight: 400;
          font-size: 15px;
          color: #0F1826;
        }
      }
    }

    .invite-btn {
      width: 314px;
      padding: 8px 0;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 24px;
      text-align: center;
      background: linear-gradient(142deg, #163ccc 0%, #973eff 100%);
      border-radius: 40px;
      margin: 50px auto;
    }
  }
</style>